import { Address, DeliveryDateType, DocumentStatus, GenericObject, Media, copyFields, fixDates } from '@synergy/models';

import { Contact } from './contact';
import { Customer } from './customer';
import { PurchaseOrderItem } from './purchase-order-item';
import { Supplier } from './supplier';
import { User } from './user';

export class PurchaseOrder {
    public id!: number;
    public number!: string;
    public orderReference!: string;
    public salesOrderNumber!: string;
    public salesOrderId!: number;
    public orderDate!: Date;
    public customerOrderNumber!: string;
    public sendPurchaseOrder!: boolean;
    public title!: string;
    public costCentre!: string;
    public commission!: string;
    public internalNote!: string;
    public status!: DocumentStatus;
    public netShippingCosts!: number;
    public netSurcharge!: number;
    public responsibleContact!: Contact;
    public customerAccount?: Customer;
    public customerContact?: Contact;
    public customerAvisoContact?: Contact;
    public supplierAccount?: Supplier;
    public supplierContact?: Contact;
    public noteToSupplier!: string;
    public currency!: string;
    public isTaxFree!: boolean;
    public termsOfDeliveryContent!: string;
    public supplierBonus!: string;
    /** As the endpoint sends it; the portal read `desiredDeliveryDate`, which it never sends (#2267). */
    public deliveryDate?: Date;
    public deliveryDateType?: DeliveryDateType;
    public totalPrice!: number;
    public totalNetPrice!: number;
    public deliveryAddress!: Address;
    public invoiceAddress?: Address;
    public purchaseOrderItems!: PurchaseOrderItem[];
    public createdAt!: Date;
    public updatedAt?: Date;
    public createdBy!: User;
    public updatedBy?: User;
    public media!: Media[];

    public static fromPlainObject(object: GenericObject): PurchaseOrder {
        const order = new PurchaseOrder();

        copyFields(object, order);

        if (object['responsibleContact']) {
            order.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['customerAccount']) {
            order.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['customerContact']) {
            order.customerContact = Contact.fromPlainObject(object['customerContact']);
        }

        if (object['customerAvisoContact']) {
            order.customerAvisoContact = Contact.fromPlainObject(object['customerAvisoContact']);
        }

        if (object['supplierAccount']) {
            order.supplierAccount = Supplier.fromPlainObject(object['supplierAccount']);
        }

        if (object['supplierContact']) {
            order.supplierContact = Contact.fromPlainObject(object['supplierContact']);
        }

        if (object['deliveryAddress']) {
            order.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['invoiceAddress']) {
            order.invoiceAddress = Address.fromPlainObject(object['invoiceAddress']);
        }

        if (object['purchaseOrderItems']) {
            order.purchaseOrderItems = object['purchaseOrderItems'].map(PurchaseOrderItem.fromPlainObject);
        }

        if (object['media']) {
            order.media = object['media'].map(Media.fromPlainObject);
        }

        fixDates(order, ['orderDate', 'deliveryDate', 'createdAt', 'updatedAt']);

        return order;
    }
}
